// @ts-strict-ignore
import Tag from 'components/Tag'
import React from 'react'
import { useFragment, graphql } from 'react-relay'
import { ApplicationStatusTextTag_JobApplication$key } from '__generated__/ApplicationStatusTextTag_JobApplication.graphql'

export interface IApplicationStatusTextTagProps {
  jobApplicationFragmentRef: ApplicationStatusTextTag_JobApplication$key
}

function ApplicationStatusTextTag(props: IApplicationStatusTextTagProps) {
  const { jobApplicationFragmentRef } = props

  const jobApplication = useFragment(
    graphql`
      fragment ApplicationStatusTextTag_JobApplication on JobApplication {
        status
      }
    `,
    jobApplicationFragmentRef,
  )

  let text: string

  // for now, it's only important for this to show pre-screening related status explanations
  // TODO: handle other cases that might be applicable pre-screening
  switch (jobApplication?.status) {
    case 'job_application_draft':
      text = 'Finish your profile and send the application to continue'
      break

    case 'job_application_sent':
      text = 'The client is reviewing your application'
      break

    case 'rejected':
      text = 'The client rejected your application - browse other jobs from the opportunities tab'
      break
  }

  if (text) {
    return (
      <Tag>
        {text}
      </Tag>
    )
  }

  return null
}

export default React.memo(ApplicationStatusTextTag)
